
import apiWorker from '../apiWorker'

const admin_alerts = {
    search: (data) =>  apiWorker('post', `/api/v1/core/admin_alerts/search`, data, true),
}

export default admin_alerts;